// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  DeleteItemPricingResponse,
  deleteItemPricing,
} from '@/items/api/delete-item-pricing';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface UseDeleteItemPricingOptions {
  itemKey: string;
  onSuccess?: (data: DeleteItemPricingResponse) => void;
}

export function useDeleteItemPricing(options: UseDeleteItemPricingOptions) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => deleteItemPricing(options.itemKey),
    onSuccess: (data) => {
      queryClient.setQueryData(['item', options.itemKey], {
        item: data.item,
        metadata: data.metadata,
      });
      options.onSuccess?.(data);
    },
  });
}
